var map = {
  "./cs.json": [
    "Toh",
    [
      "hry"
    ]
  ],
  "./en.json": [
    "Pml",
    [
      "ddy"
    ]
  ],
  "./pl.json": [
    "cqn",
    [
      "uz"
    ]
  ],
  "./ru.json": [
    "rR",
    [
      198
    ]
  ],
  "./tr.json": [
    "xD9",
    [
      "r2"
    ]
  ],
  "./ja.json": [
    "WEz",
    [
      "sd"
    ]
  ],
  "./zh.json": [
    "u33",
    [
      "wa"
    ]
  ],
  "./pt-br.json": [
    "nse",
    [
      50
    ]
  ],
  "./de.json": [
    "J3a",
    [
      "3f2"
    ]
  ],
  "./es.json": [
    "H4",
    [
      "9s"
    ]
  ],
  "./fr.json": [
    "Rj8",
    [
      "voy"
    ]
  ],
  "./it.json": [
    "z7y",
    [
      "tm"
    ]
  ],
  "./ko.json": [
    "CGD",
    [
      "8r"
    ]
  ],
  "./pt.json": [
    "aza",
    [
      "on"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "lh";
module.exports = __rspack_async_context;
